// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1RcsX","title":"ClientCherryInfo_title__1nBIg","itemText":"ClientCherryInfo_itemText__S7H2F"};